import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'offline-voip-peer-aggregation-summary',
  templateUrl: './offline-voip-peer-aggregation-summary.component.html',
  styleUrls: ['./offline-voip-peer-aggregation-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class OfflineVoipPeerAggregationSummaryComponent implements OnInit {

  cluster: any;

  @Input()
  set selection(selection: any) {
    this.dataInitialization(selection);
  }

  constructor() {}

  ngOnInit(): void {

  }

  private dataInitialization(selection: any): void {
    if (_.isNil(selection)) { return; }

    const shapes = selection.nodes;
    const connections = selection.edges;
    if (shapes.length === 1 && connections.length === 0 && shapes[0].shapeType === 'cluster') {
      this.cluster = shapes[0];
    }
  }
}
